/* eslint-disable quotes */
import ApiService from "./api.service";
// import ApiMockService from "./api.mock.service"
import CacheService from "./cache.service";

const TagService = {
  // List Tags for id or search;
  getAll: async function (params = {}, lang = null) {
    const response = await ApiService._get("api/core/tag", params, lang);
    return response.data;
  },

  /**
   * Gets tags from API or Cache Storage.
   * @param {Object} params - filters or query params
   * @param {Object} options - options
   * @param {String} options.lang - language
   * @param {Boolean} options.withTranslations - if true, includes translations in the response (all available languages)
   * @param {Boolean} options.forceRefresh - if true, ignores the cache and goes to the backend
   * @param {Number} options.ttlDays - number of days to keep the cache valid
   * @returns {Array} list of tags
   *
   * @example
   * // Get all tags in English, without translations, forcing refresh, cache valid for 2 days
   * const tags = await TagService.getAllList({
   *   lang: 'en',
   *   withTranslations: false,
   *   forceRefresh: true,
   *   ttlDays: 2
   * })
   * console.log(tags)
   * // Output:
   * // {
   * //   "success": true,
   * //   "msg": "Tags list fetched",
   * //   "data": {
   * //     "langs": ["en"],
   * //     "withTranslations": false,
   * //     "list": [
   * //       { "id": 40196, "tag_id": 20098, "name": "Adaptogens", "lang": "en" },
   * //       { "id": 40176, "tag_id": 20088, "name": "Added Sugars", "lang": "en" },
   * //     ]
   * //   }
   * // }
   */
  async getAllList({ lang, withTranslations = false, forceRefresh = false, ttlDays = 1 } = {}) {
    const ttlMs = ttlDays * 864e5;
    const langParam = lang || localStorage.getItem("lang") || "en";
    const CACHE_KEY = `api/core/tag/all-list-by-lang/${langParam}?withTranslations=${withTranslations}`;

    // Look in cache
    if (!forceRefresh) {
      const cached = await CacheService.get(CACHE_KEY, { ttlMs });
      if (cached) return cached;
    }

    // Real fetch
    const response = await ApiService._get(CACHE_KEY);
    const data = response?.data;

    // Save in cache
    if (data) {
      await CacheService.set(CACHE_KEY, data);
    }

    return data;
  },
};

export default TagService;
